<template>
    <page>
        <div class="shadow-25 column items-center justify-center central-content">
            <v-header :title="$t('export file')" icon="cloud download"></v-header>
            <card width="400px" style="margin: 0 auto;">

                <form class="q-pt-xs gutter-xs row" method="post" target="_blank"
                :action="`${config.appUrl}/stock-movement/export`">
                    <input type="hidden" name="partial" :value="partial">

                    <v-checkbox path="partial"
                                v-model="partial"
                                :label="$t('download only the stock movements registered after the last export.')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>

                    <!-- Submit Button -->
                    <div class="row justify-center col-12 q-mt-md">
                        <v-button outline
                                  :label="$t('download')"
                                  icon="cloud download"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  type="submit">
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
    </page>
</template>

<script>
    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('export file')}
        },

        data() {
            return {
                config,
                partial: false,
                form: {}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/stock-movement/export.vue